import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import NewVehicle from "./NewVehicle"
import { isEbay } from "../../../../v1/helpers/affiliationHelpers"
import EbayWelcomeModal from "../../Affiliations/EbayWelcomeModal"
import { isEbayTireOrder } from "../../../../v1/helpers/orderHelpers"

const AddVehicle = ({ asModal = false, closeModalHandler, user }) => {
  return (
    <>
      {isEbay() && isEbayTireOrder(user.active_carts?.[0]) && <EbayWelcomeModal />}
      <NewVehicle asModal={asModal} closeModalHandler={closeModalHandler} serviceRequest={true} />
    </>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let vehicle = state.selectedVehicle.selectedVehicle || {}
  let activeVehicle = (user.vehicles || []).find((v) => v.id === user.activeVehicleId) || {}

  return {
    user: user,
    vehicle: vehicle,
    activeVehicle: activeVehicle
  }
}

export default withRouter(connect(mapStateToProps)(withTranslation("vehicleDetails")(AddVehicle)))
